import { Popover } from "@progress/kendo-react-tooltip";
import { info } from "../../assets/icons";
import { useRef, useState } from "react";

const TooltipWrapper = (props: {
    text: string;
    title?: string;
}) => {
    const anchor = useRef<HTMLButtonElement>(null);
    const [show, setShow] = useState(false);

    return (<>
        <Popover
            show={show}
            position="top"
            anchor={anchor.current && anchor.current}
            title={props?.title && <h5 style={{margin: 0, paddingLeft: "0.5rem"}}>{props?.title}</h5>}
        ><div style={{ maxWidth: 300, padding: "0 0.5rem 0.5rem" }}>
            <div style={{fontSize:"1rem"}} dangerouslySetInnerHTML={{ __html: props.text }}></div>
            <div style={{ marginTop: "1rem" }}>
                <button className="btn btn-outline-primary btn-sm" type="button" onClick={() => setShow(false)}>Close</button>
            </div>
            </div>
        </Popover>
        <button ref={anchor} className="btn btn-transparent btn-tooltip" type="button" onClick={() => setShow(!show) }><img src={info} title={props.text} alt={props.text} style={{ width: "1.2rem", height: "1.2rem" }} /></button>
    </>
    );
}
export default TooltipWrapper;